module.exports = __webpack_public_path__ + "img/mail.e0620ff5.svg";